import diagnostics from '../../api/diagnostics';
import {questionsForm} from "../../data/diagnosticForm";
import {getTranslationString} from "../../helper";

const success = {
    CREATE_DIAGNOSTIC_SUCCESS: {
        title: "Succès",
        content: "Diagnostic créé avec succès"
    },
    UPDATE_DIAGNOSTIC_SUCCESS: {
        title: "Succès",
        content: "Diagnostic mis à jour"
    },
}
const errors = {
    CREATE_DIAGNOSTIC_ERROR: 'Erreur lors de la création du diagnostic, merci de réessayer',
    UPDATE_DIAGNOSTIC_ERROR: 'Erreur lors de la mise à jour du diagnostic, merci de réessayer',
}
export function defaultFormData() {
    const result = {};
    questionsForm.forEach(item => {
        const key = item.id;
        result[key] = {};

        item.questions.forEach(question => {
            const questionKey = question.id;

            if (question.type === 'checkbox') {
                result[key][questionKey] = [];
            } else if (question.type === 'multiple') {
                result[key][questionKey] = [''];
            }
            else {
                result[key][questionKey] = '';
            }
        });
    });


    return result;
}

function formDataToDiagnostic(formData) {
  // list of all questions from form that don't exist in the form
    const result = formData;
    questionsForm.forEach(section => {
        const id = section.id;
        section.questions.forEach(question => {
            if(!formData[id][question.id]) {
                const questionId = question.id;
                if (question.type === 'checkbox') {
                    result[id][questionId] = [];
                } else if (question.type === 'multiple') {
                    result[id][questionId] = [''];
                } else {
                    result[id][questionId] = '';
                }
            }
        });
    });

    return result;
}

// initial state
const state = {
    form: {
        id: null,
        type: null,
        description: null,
        data: defaultFormData(),
    },
    showModal: false
}

// getters
const getters = {
    getDiagnosticTypeOptions: () => {
        return [
            {text: getTranslationString('DIAGNOSTIC_GONARTHROSE'), value: 'DIAGNOSTIC_GONARTHROSE'},
            //{text: getText('DIAGNOSTIC_ARTHROSE_HANCHE'), value: 'DIAGNOSTIC_ARTHROSE_HANCHE'},
            {text: getTranslationString('DIAGNOSTIC_LCA'), value: 'DIAGNOSTIC_LCA'},
            {text: getTranslationString('DIAGNOSTIC_LCP'), value: 'DIAGNOSTIC_LCP'},
            {text: getTranslationString('DIAGNOSTIC_LPI'), value: 'DIAGNOSTIC_LPI'},
            {text: getTranslationString('DIAGNOSTIC_LPE'), value: 'DIAGNOSTIC_LPE'},
            {text: getTranslationString('DIAGNOSTIC_LM'), value: 'DIAGNOSTIC_LM'},
            {text: getTranslationString('DIAGNOSTIC_CARTI_NON_DEG'), value: 'DIAGNOSTIC_CARTI_NON_DEG'},
            {text: getTranslationString('DIAGNOSTIC_ROTULE'), value: 'DIAGNOSTIC_ROTULE'},
            {text: getTranslationString('DIAGNOSTIC_LESION_CARTI_ROTULE'), value: 'DIAGNOSTIC_LESION_CARTI_ROTULE'},
            {text: getTranslationString('DIAGNOSTIC_PTG_DOULOUREUSE'), value: 'DIAGNOSTIC_PTG_DOULOUREUSE'},
            {text: getTranslationString('DIAGNOSTIC_OTHER'), value: 'DIAGNOSTIC_OTHER'},
        ]
    }
}

// actions
const actions = {
    initFormDiagnostic({commit, rootState }) {
        //get info from medical case
        commit('initForm',  rootState.medical_cases.selectedMedicalCase.diagnostic);
    },

    saveDiagnostic({ state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            if (state.form.id == null) {
                diagnostics.add(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, state.form, rootState.axios).then(result => {
                    commit('notifications/showSuccess', {
                        title: success.CREATE_DIAGNOSTIC_SUCCESS.title,
                        content: success.CREATE_DIAGNOSTIC_SUCCESS.content
                    }, {root: true})
                    resolve(result)
                }).catch(reason => {
                    commit('notifications/showError', {
                        title: errors.CREATE_DIAGNOSTIC_ERROR, content: reason
                    }, {root: true})
                    reject(reason)
                })
            } else {
                diagnostics.update(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, state.form.id, state.form, rootState.axios).then(result => {
                    commit('notifications/showSuccess', {
                        title: success.UPDATE_DIAGNOSTIC_SUCCESS.title, content: success.UPDATE_DIAGNOSTIC_SUCCESS.content
                    }, { root: true })
                    resolve(result)
                }).catch(reason => {
                    commit('notifications/showError', {
                        title: errors.UPDATE_DIAGNOSTIC_ERROR, content: reason
                    }, { root: true })
                    reject(reason)
                })
            }
        })
    }
}

// mutations
const mutations = {
    setFormId (state, value) {
        state.form.id = value
    },
    setFormType (state, value) {
        state.form.type = value
    },
    setFormDescription (state, value) {
        state.form.description = value
    },
    setFormData (state, value) {
        state.form.data = value
    },
    initForm (state, value) {
        if (value != null) {
            state.form.id = value.id
            state.form.type = value.type
            state.form.description = value.description
            state.form.data = value.data != null ? formDataToDiagnostic(value.data) : defaultFormData()
        } else {
            state.form.id = null
            state.form.type = null
            state.form.description = null
            state.form.data = defaultFormData()
        }
    },
    setShowModal (state, value) {
        state.showModal = value
    },
    setSelectedDiagnosticIdByMedicalCaseId (state, value) {
        state.selectedDiagnosticId = value
    },
    // form
    addInputMultiple (state, { sectionId, questionId }) {
        state.form.data[sectionId][questionId].push('')
    },
    removeInputMultiple (state, { sectionId, questionId, index }) {
        state.form.data[sectionId][questionId].splice(index, 1)
    },
    setInputChanged (state, { sectionId, questionId, value, optionIndex }) {
        if(optionIndex !== undefined) {
            state.form.data[sectionId][questionId][optionIndex] = value
        } else {
            state.form.data[sectionId][questionId] = value
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
